import { faChevronDown, faChevronUp } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';

type CollapsibleSectionProps = {
  count: number;
  title: string;
  children: React.ReactNode;
}

function CollapsibleSection({ count, title, children } : CollapsibleSectionProps) {
  const [isOpen, setIsOpen] = React.useState(true);

  return (
    <div className="mb-2 mx-1 card">
      <div
        className="card-header clickable"
        onClick={() => setIsOpen(!isOpen)}
      >
        <div className="text-center mb-2">
          <h5 className="mb-0">{title} ({count})</h5>
          <FontAwesomeIcon icon={isOpen ? faChevronDown : faChevronUp} />
        </div>
      </div>
      {isOpen && (
        <div className="p-2 card-body">
          {children}
        </div>
      )}
    </div>
  );
}

export default CollapsibleSection;
